<script lang="ts">
  import type { Snippet } from "svelte"
  import { autoAllocateGridSpans, cn, headerVariants } from ".."
  import { getTableRootContext } from "./Table.svelte"

  const rootCtx = getTableRootContext()

  type Props = {
    cols?: number
    class?: string
    children?: Snippet
  }

  let { cols = undefined, class: cssClass = "", children }: Props = $props()

  let ref: HTMLDivElement = $state()!

  const spans = $derived(
    autoAllocateGridSpans(
      Array.from(ref?.querySelectorAll("[role='columnheader']") ?? []),
      cols ?? $rootCtx.cols
    )
  )

  $effect(() => {
    $rootCtx.headerLabels = Array.from(
      ref?.querySelectorAll("[role='columnheader']") ?? []
    ).map((e) => e.textContent)
  })
</script>

<div
  bind:this={ref}
  class={cn(
    headerVariants({
      variant: $rootCtx.variant,
      responsive: $rootCtx.responsive,
    }),
    cssClass
  )}
  role="rowgroup"
  style:grid-template-columns={spans.map((span) => `${span}fr`).join(" ")}
>
  {@render children?.()}
</div>
